<h2 mat-dialog-title>
    {{ data?.id ? ("consumer_edit" | transloco) : ("consumer_create" | transloco) }}
</h2>

<mat-divider></mat-divider>

<mat-dialog-content class="px-4">
    <mat-tab-group
        id="tab-group"
        [dynamicHeight]="false"
    >
        <form [formGroup]="consumerForm">
            <mat-tab [label]="'edit' | transloco">
                <br>
                <pixl-consumer-info [parentForm]="consumerForm"></pixl-consumer-info>
            </mat-tab>

            <mat-tab [label]="'metadata' | transloco">
                <br>
                <pixl-object-consumer-metadata
                    [parentForm]="consumerForm"
                    [consumerId]="data?.id || null"
                    [objectType]="''"
                    [isConsumerField]="true"
                ></pixl-object-consumer-metadata>
            </mat-tab>

            <mat-tab [label]="'metadata_learn_objects' | transloco">
                <br>
                <pixl-consumer-object-type-metadata
                    [parentForm]="consumerForm"
                    [savedLearnObjectTypes]="consumerForm.get('learnObjectTypeDescriptions')?.value"
                >
                </pixl-consumer-object-type-metadata>
            </mat-tab>

            <mat-tab [label]="'global_metadata' | transloco">
                <br>
                <pixl-consumer-metadata [parentForm]="consumerForm"></pixl-consumer-metadata>
            </mat-tab>

            <mat-tab [label]="'player_functionality' | transloco">
                <br>
                <pixl-consumer-player-config
                    [parentForm]="consumerForm"
                    [consumerId]="data?.id"
                    [resetTheme]="resetTheme"
                    [competencies]="competencies"
                ></pixl-consumer-player-config>
            </mat-tab>
        </form>
    </mat-tab-group>
</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions align="end">
    <button
        mat-button
        (click)="onCancel()"
    >{{ "cancel" | transloco }}</button>
    <button
        mat-raised-button
        color="primary"
        (click)="onSave()"
        [disabled]="!consumerForm.valid"
    >{{ "save" | transloco }}</button>
</mat-dialog-actions>